import { PrimaryFullScreenSpinner, TabLink, TabLinkContainer } from "@repo/ui";
import { NotFoundError } from "@repo/utils";
import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { AdminPageContainer } from "~/components/layout/AdminPageContainer";
import { AdminPageHeader } from "~/components/layout/AdminPageHeader";
import { opsHead } from "~/head";

export const Route = createFileRoute(
  "/__auth/ledger/transactions_/$transactionId",
)({
  head: () => opsHead("Ledger Transaction"),
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

function View() {
  const { transactionId } = useParams({ strict: false });
  if (!transactionId) {
    throw new NotFoundError();
  }

  return (
    <AdminPageContainer>
      <AdminPageHeader
        title="Transaction"
        subtitle={<div>{transactionId}</div>}
      />
      <TabLinkContainer className="mb-10">
        <TabLink
          to={`/ledger/transactions/${transactionId}`}
          title="Overview"
          end
        />
        <TabLink
          to={`/ledger/transactions/${transactionId}/entries`}
          title="Entries"
        />
      </TabLinkContainer>
      <div className="mt-4">
        <Outlet />
      </div>
    </AdminPageContainer>
  );
}
